<template>
  <a
    v-if="event.questions.length > 0"
    :href="event.preview_url"
    class="Button Button--green-outline PreviewWebForm"
    target="_blank"
    rel="noreferrer noopener"
    title="Preview the event based on the last time it was updated."
  >Preview <span class="Icon-s Icon-eye" />
  </a>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('events', {
      event: (state) => state.event,
    }),
    ...mapState('forms', {
      formQuestions: (state) => state.form.questions,
    }),
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style scoped lang="less">
.CreationSteps {
  position: absolute;
  top: -40px;
  left: 0;

  @media only screen and (max-width: 1490px) {
    width: 100%;
  }

  .PreviewWebForm{
    height: 100%;
  }

  a {
    color: grey;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px 10px;
    background: rgba(255, 255, 255, 0.54);
    border: 1px solid #eaeaea;

    &.disabled {
      opacity: 0.3;
      pointer-events: none;
    }
    &.current-view {
      color: black;
      background: white;
      border-bottom: none;
      flex-shrink: 0;
    }

    .Icon-check-circle {
      color: #046ff0;
    }

  }
}
</style>
